/**
 * Call-module features that exist in the UI but have no working backend yet.
 * Flip to `true` once the feature is wired end-to-end.
 */

/** Meeting recording — no recording backend exists yet, so every record control is hidden. */
export const RECORDING_ENABLED = false;
